import _ from 'lodash';
import { createSelector } from 'reselect';
import { isFinishedOnBoardingSelector } from './organization';
import { repositoriesSelector } from './repositories';
import { gitIntegrationsSelector } from './sensors-authorizations';

export const isPostOnboardingWithoutReposSelector = createSelector(
  [isFinishedOnBoardingSelector, repositoriesSelector, gitIntegrationsSelector],
  (isFinishedOnboarding, repositories, gitIntegrations) =>
    isFinishedOnboarding &&
    _.size(repositories) === 0 &&
    _.size(gitIntegrations) > 0
);
